import { FaChevronDown } from "react-icons/fa";
import { IoMdMenu } from "react-icons/io";
import { scrollToSection } from "../../../../utils/helpers";
import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { BENEFITS_ID, INTEGRATION_ID, WHY_CHAT_ME_ID } from "../../constant";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "antd";
import LanguageSwitcherLandingPage from "@/components/LanguageSwitcherLandingPage";
import logoVN from "@/assets/images/logo-vn.png";
import { FormattedMessage } from "react-intl";

const items = [
  {
    key: "1",
    label: "Vietnam",
  },
  {
    type: "divider",
  },
  {
    key: "2",
    label: "English",
  },
];
const Header = () => {
  const navigate = useNavigate();
  const [isOpenNavbar, setIsOpenNavbar] = useState(false);
  return (
    <div
      className="bg-[#071807] fixed w-full text-base z-[99]"
      style={{ fontFamily: "Lexend Deca, sans-serif" }}
    >
      <div className="h-[60px] md:h-[90px] px-4 bg-[#071807] flex justify-between items-center md:w-[90%] max-w-[1000px] sm:max-w-[640px] md:max-w-[768px] lg:max-w-[1024px] xl:max-w-[1100px] 2xl:max-w-[1536px] m-auto box-border">
        <div className="flex items-center justify-center gap-2 cursor-pointer">
          {/* logo */}
          <img
            src="/media/images/landing-page/bot-icon-1.png"
            alt="chat_bot"
            className="w-[31px] md:w-[42px] md:h-[42px]"
          />
          <div>
            <div className="text-[#50B553] uppercase  font-semibold">
              chatme.vn
            </div>
            <div className="text-white uppercase text-center text-xs">
              ai chatbot
            </div>
          </div>
        </div>
        <IoMdMenu
          className="text-white text-[32px] block md:hidden cursor-pointer hover:text-primary-1"
          onClick={() => setIsOpenNavbar(true)}
        />
        {isOpenNavbar && (
          <div className="fixed right-0 top-0 w-full h-[100vh] z-5 p-5 bg-black flex flex-col gap-2 text-white font-semibold">
            <div className="flex justify-end items-center">
              <IoMdClose
                className="text-[24px] hover:text-primary-1 cursor-pointer"
                onClick={() => setIsOpenNavbar(false)}
              />
            </div>
            <hr />
            <ul className="flex flex-col gap-3 py-2">
              <li
                className="hover:text-primary-1 cursor-pointer"
                onClick={() => {
                  navigate("/");
                  setIsOpenNavbar(false);
                }}
              >
                <FormattedMessage id="LANDINGPAGE.HEADER.HOME" />
              </li>
              <li
                className="hover:text-primary-1 cursor-pointer"
                onClick={() => {
                  navigate("/pricing");
                  setIsOpenNavbar(false);
                }}
              >
                <FormattedMessage id="LANDINGPAGE.HEADER.PRICING" />
              </li>
              <li
                className="hover:text-primary-1 cursor-pointer"
                onClick={() => {
                  navigate("/contact");
                  setIsOpenNavbar(false);
                }}
              >
                <FormattedMessage id="LANDINGPAGE.HEADER.CONTACT" />
              </li>
            </ul>
          </div>
        )}
        <ul className="flex gap-6 pl-20 text-white md:flex">
          <li
            className="hover:text-primary-1 cursor-pointer"
            onClick={() => navigate("/")}
          >
            <FormattedMessage id="LANDINGPAGE.HEADER.HOME" />
          </li>
          <li
            className="hover:text-primary-1 cursor-pointer"
            onClick={() => navigate("/pricing")}
          >
            <FormattedMessage id="LANDINGPAGE.HEADER.PRICING" />
          </li>
          <li
            className="hover:text-primary-1 cursor-pointer"
            onClick={() => navigate("/contact")}
          >
            <FormattedMessage id="LANDINGPAGE.HEADER.CONTACT" />
          </li>
        </ul>
        <div className="flex justify-center items-center gap-6 md:flex text-sm">
          <div
            className="px-8 py-2 border border-[#50b553] bg-[#9DFFA033] rounded-[11px] text-[#50B553] flex items-center justify-center cursor-pointer hover:text-white"
            onClick={() => navigate("/auth/signup")}
          >
            <FormattedMessage id="LANDINGPAGE.FOOTER.JOIN_NOW" />
          </div>
          {/* language selection */}
          <div className="flex justify-center items-center gap-2 text-white">
            <LanguageSwitcherLandingPage />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
